import React from 'react'
import RightArrow from '../../assets/images/rightArrow.svg';
import leftArrow from '../../assets/images/leftArrow.svg';
import './style.css'
export default function AppButton({title,style,isLeft,onClick}) {
    

    return (
        <div onClick={onClick} style={style} className='app-button-main'>
        <p className='button-text'>{title}</p> 
         <img src={isLeft? leftArrow:RightArrow} className='button-right-arrow' />
        </div>
    )
}
